<template>
    <div>
        <b-form-textarea v-model="text" @focus.native="$emit('updateValue')" @input="$emit('input', text)" :maxlength="maxLength"></b-form-textarea>
        <small class="d-inline-block float-right mt-1" style="color: #333">{{ text.length }} / {{ maxLength }} characters limit</small>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name: 'limited-text-area',
    data() {
        return {
            text: ''
        }
    },
    props: {
        maxLength: {
            type: Number,
            default: 500
        }
    },
    computed: {
        remainingCharacters() {
            return this.maxLength - this.text.length;
        }
    }
}
</script>